import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC8G4ipqWm0aLhLyr5LzEIXfS3T_LJmaX8",
  authDomain: "ctemplet-b7e15.firebaseapp.com",
  projectId: "ctemplet-b7e15",
  storageBucket: "ctemplet-b7e15.firebasestorage.app",
  messagingSenderId: "135432551314",
  appId: "1:135432551314:web:6a49fd8c07c210f1835f4b",
  measurementId: "G-TCZR77CZNW",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
